[...document.querySelectorAll('.js-wishlist-trigger')].map((trigger) => trigger.addEventListener('click', (e) => {
    e.preventDefault();
}));
